module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_20.f81c03e8.jpg";